<template>
  <div class="export-footer">
    <p class="text-center">JALA Office, Ground Floor Sahid J-Walk, Jl. Babarsari No. 2, Janti, Caturtunggal, Depok, Sleman, <br>Daerah Istimewa Yogyakarta, Indonesia 55281</p>
    <p class="text-center">Telp: 0274-8000020 (Office)</p>
  </div>
</template>

<script>
export default {
  name: 'export-footer',
}
</script>

<style lang="scss" scoped>
.export-footer {
  color: #0084F3;
  position: fixed;
  bottom: 0;
  z-index: -1;
}
</style>